// src/App.js
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AdminProvider } from "./context/AdminContext";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";

// Customer pages
import Home from "./pages/Home";
import Products from "./pages/Products";
import Projects from "./pages/Projects";
import Gallery from "./pages/Gallery";
import ContactUs from "./pages/ContactUs";
import ProductDetails from "./pages/ProductDetails";
import ProjectDetails from "./pages/ProjectDetails"; 

// Admin pages
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";

// Manage Products
import AddProduct from "./pages/admin/ManageProducts/AddProduct";
import ManageProducts from "./pages/admin/ManageProducts/ManageProducts";
import EditProduct from "./pages/admin/ManageProducts/EditProduct";

// Manage Projects
import AddProject from "./pages/admin/ManageProjects/AddProject";
import ManageProjects from "./pages/admin/ManageProjects/ManageProjects";
import EditProject from "./pages/admin/ManageProjects/EditProject";

// Manage Gallery
import AddImage from "./pages/admin/ManageGallery/AddImage";
import ManageGallery from "./pages/admin/ManageGallery/ManageGallery";

// Layout wrapper
function Layout({ children }) {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdminRoute && <Navbar />}
      {children}
      {!isAdminRoute && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AdminProvider>
        <Layout>
          <ScrollToTop />
          <Routes>

            {/* Customer pages */}
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<ProductDetails />} />

            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetails />} /> 

            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<ContactUs />} />

            {/* Admin login */}
            <Route path="/admin/login" element={<Login />} />

            {/* Admin protected */}
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            {/* Manage Products */}
            <Route
              path="/admin/manage-products"
              element={
                <ProtectedRoute>
                  <ManageProducts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/manage-products/add"
              element={
                <ProtectedRoute>
                  <AddProduct />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/manage-products/edit/:id"
              element={
                <ProtectedRoute>
                  <EditProduct />
                </ProtectedRoute>
              }
            />

            {/* Manage Projects */}
            <Route
              path="/admin/manage-projects"
              element={
                <ProtectedRoute>
                  <ManageProjects />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/manage-projects/add"
              element={
                <ProtectedRoute>
                  <AddProject />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/manage-projects/edit/:id"
              element={
                <ProtectedRoute>
                  <EditProject />
                </ProtectedRoute>
              }
            />

            {/* Manage Gallery */}
            <Route
              path="/admin/manage-gallery"
              element={
                <ProtectedRoute>
                  <ManageGallery />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/manage-gallery/add"
              element={
                <ProtectedRoute>
                  <AddImage />
                </ProtectedRoute>
              }
            />

          </Routes>
        </Layout>
      </AdminProvider>
    </Router>
  );
}

export default App;